<template>
  <label
    :class="[
      'inp_func',
      {
        none_text: !hasLabel,
      },
    ]"
    tabindex="0"
  >
    <input
      type="checkbox"
      v-bind="attrs"
      v-on="listeners"
      :checked="_checked"
    />
    <span class="txt"><slot />{{ label }}</span>
  </label>
</template>

<script>
import uniq from "lodash/uniq";
export default {
  model: {
    prop: "model",
    event: "update",
  },
  props: {
    label: String,
    model: [Array, Boolean],
    value: [String, Number],
    checked: {
      type: Boolean,
      default: undefined,
    },
  },
  computed: {
    hasLabel() {
      return Boolean(this.label || this.$slots.default);
    },

    attrs() {
      const { model, ...restProps } = this.$props;
      return { ...this.$attrs, ...restProps, checked: this._checked };
    },

    listeners() {
      return { ...this.$listeners, input: this.onInput };
    },

    _checked() {
      if (typeof this.checked === "boolean") return this.checked;

      if (Array.isArray(this.model)) {
        return this.model.includes(this.value);
      }

      return this.model;
    },
  },

  methods: {
    onInput(e) {
      const checked = e.target.checked;

      if (Array.isArray(this.model)) {
        if (checked) this.$emit("update", uniq([...this.model, this.value]));
        else
          this.$emit(
            "update",
            this.model.filter((v) => v !== this.value)
          );
        return;
      }
      this.$emit("update", checked);
    },

    focus() {
      // input[type=checkbox]가 display:none이라 focusing 불가
      // wrap(label) element로 대체
      this.$el.focus();
    },
  },
};
</script>

<style>
</style>